// English strings for count sessions (kitchen flow, Stage 3). One table so an
// Urdu one can be dropped in later.
export const CT = {
  tab: 'Count',
  kitchenTab: 'Count the kitchen',
  title: 'Count the shelves',
  subtitle: 'Walk the shelves in order and enter what is there. Each count saves as you go. The store manager approves it, then stock is set to your count.',
  where: 'Where are you counting?',
  start: 'Start a count',
  everyItem: 'Include every item, not only what this place holds',
  noKitchen: 'There is no kitchen to count yet.',
  noPlace: 'Choose a place first.',
  book: (q: string, unit: string) => `Book: ${q} ${unit}`,
  notCounted: '—',
  waitingBadge: 'to approve',
  counted: (n: number, total: number) => `${n} of ${total} counted`,
  differences: (n: number) => (n === 1 ? '1 item differs' : `${n} items differ`),
  more: (q: string, unit: string) => `${q} ${unit} more`,
  less: (q: string, unit: string) => `${q} ${unit} short`,
  matches: 'Matches',
  clear: 'Clear',
  save: 'Save counts',
  saving: 'Saving…',
  saved: 'Counts saved',
  unsaved: (n: number) => (n === 1 ? '1 count not saved yet' : `${n} counts not saved yet`),
  allSaved: 'All counts saved',
  saveRetry: 'Not saved yet — kept on this device, will save when the connection is back.',
  notSavedYet: 'Some counts are not saved yet. Check the connection and try again.',
  blind: 'Count what you see on the shelf. The book figure shows to the approver after you send the count.',
  approverHint: 'Check the differences, then approve or send the count back to be recounted.',
  submit: 'Send for approval',
  submitted: 'Sent to the store for approval',
  approve: 'Approve and set stock',
  approveConfirm: (n: number) => `Set stock to the counted figures? ${n === 1 ? '1 item changes' : `${n} items change`}.`,
  approved: 'Count approved — stock updated',
  approveNote: 'Note (needed if you counted this yourself)',
  reopen: 'Send back to counting',
  reopened: 'Count sent back to counting',
  withdrawConfirm: 'Withdraw and cancel this count? Nothing will change in stock.',
  cancel: 'Cancel this count',
  cancelConfirm: 'Cancel this count? Nothing will change in stock.',
  cancelled: 'Count cancelled',
  done: {
    submit: 'Sent for approval',
    approve: 'Count approved — stock updated',
    cancel: 'Count cancelled',
    reopen: 'Count sent back to counting',
  } as Record<'submit' | 'approve' | 'cancel' | 'reopen', string>,
  waitingApproval: 'Waiting for the store manager to approve.',
  status: {
    open: 'Counting',
    submitted: 'Waiting for approval',
    approved: 'Approved',
    cancelled: 'Cancelled',
  } as Record<string, string>,
  history: 'Past counts',
  noHistory: 'No counts yet.',
  by: 'by',
  search: 'Find an item…',
  scanAdded: (name: string, q: string, unit: string) => `${name}: ${q} ${unit}`,
  scanNew: (name: string) => `${name} added to the count`,
  errors: {
    count_session_already_open: 'A count of this place is already under way — finish or cancel it first.',
    count_line_below_zero: 'Stock moved since some items were counted. Count them again.',
    count_session_nothing_counted: 'Count at least one item first.',
    count_session_not_submitted: 'Send the count for approval first.',
    count_approver_is_counter: 'Only the store manager or the owner can approve a count.',
    count_self_approve_note_required: 'You counted this yourself. Add a note to approve it.',
    count_session_not_open: 'This count has been sent. Send it back to counting to change it.',
  } as Record<string, string>,
  // Batch 6: the manager's read-only view (Reports → Kitchen flow → Counts).
  read: {
    title: 'Stock counts',
    subtitle: 'What was counted at each place. Read only — the store approves counts.',
    open: 'Open',
    back: 'All counts',
    none: 'No counts yet.',
    onlyDifferences: 'Only items that differ',
    noLines: 'Nothing was counted on this sheet.',
    noDifferences: 'Every counted item matched the book.',
    bookHidden: 'The book figures show once the count is approved.',
    cols: ['Item', 'Counted', 'Book', 'Difference'],
    started: (when: string, by: string | null) => (by ? `Started ${when} by ${by}` : `Started ${when}`),
  },
  locationHint: 'Counting at',
  back: 'Back',
  yes: 'Yes, go ahead',
}
